<style>
menu {
  margin-block-start: 0.125rem;
}
</style>

<script>
import Icon from "@local/components/images/Icon.svelte"

export let label = ""
export let className = ""
export let options = []

let showItems = false
let showAll = false

function showAllItems(show) {
  showAll = show
}
function handleMenu() {
  showItems = true
}
function closeMenu() {
  showItems = false
  showAll = false
}
</script>

<div
  class="{`relative btn btn-outline p-0 select-none ${className}`}"
  class:bg-gray-100="{!options.length}"
  class:text-gray-500="{!options.length}"
  class:border-gray-300="{!options.length}"
  class:hover:border-gray-300="{!options.length}"
  class:hover:bg-gray-100="{!options.length}"
  class:hover:text-gray-500="{!options.length}"
  class:dark:bg-tertiary-dark="{!options.length}"
  class:dark:text-gray-500="{!options.length}"
  class:dark:border-gray-400="{!options.length}"
  class:dark:hover:border-gray-400="{!options.length}"
  class:dark:hover:bg-tertiary-dark="{!options.length}"
  class:dark:hover:text-gray-500="{!options.length}"
  on:mouseenter="{handleMenu}"
  on:mouseleave="{closeMenu}"
>
  <div class="flex items-center h-8 cursor-pointer">
    <span class="text-sm font-medium mx-2 hidden lg:block">{label}</span>
    {#if showItems}
      <div class="w-8 h-8 lg:w-auto lg:h-auto flex items-center justify-center">
        <Icon size="lg">expand_less</Icon>
      </div>
    {:else}
      <div class="w-8 h-8 lg:w-auto lg:h-auto flex items-center justify-center">
        <Icon size="lg">expand_more</Icon>
      </div>
    {/if}
  </div>

  {#if showItems}
    {#if !showAll}
      <menu
        class="shadow-2xl p-0 bg-white text-black absolute right-0 w-60 overflow-hidden dark:bg-tertiary-dark dark:text-white dark:border-gray-400"
      >
        {#each options.slice(0, 6) as option}
          <a href="{option.url}" target="_blank" rel="noreferrer">
            <li
              class="relative block p-4 font-semibold text-sm cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-300 dark:hover:text-black {option.className}"
            >
              {option.label}
            </li>
          </a>
        {/each}
        {#if options.length > 6}
          <li
            class="relative block p-4 font-semibold text-sm cursor-pointer hover:bg-gray-300 dark:bg-tertiary-dark dark:hover:bg-gray-300 dark:hover:text-black"
            on:click="{showAllItems(!showAll)}"
          >
            <div>
              <Icon size="lg">expand_more</Icon>
              <span class="align-top">More</span>
            </div>
          </li>
        {/if}
      </menu>
    {:else}
      <menu
        class="shadow-2xl p-0 bg-white absolute right-0 w-60 overflow-hidden dark:bg-tertiary-dark dark:text-white dark:border-gray-400"
      >
        {#each options as option}
          <a href="{option.url}" target="_blank" rel="noreferrer">
            <li
              class="relative block p-4 font-semibold text-sm cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-300 dark:hover:text-black {option.className}"
            >
              {option.label}
            </li>
          </a>
        {/each}
        <li
          class="relative block p-4 font-semibold text-sm cursor-pointer hover:bg-gray-300 dark:bg-tertiary-dark dark:hover:bg-gray-300 dark:hover:text-black"
          on:click="{showAllItems(!showAll)}"
        >
          <div>
            <Icon size="lg">expand_less</Icon>
            <span class="align-top">Less</span>
          </div>
        </li>
      </menu>
    {/if}
  {/if}
</div>
